import { useMemo } from "react";
import { SortDescriptor } from "react-aria-components";

import { FlowsProjectRoleBindingView } from "shared/Flows/Projects/useFlowsProject/types";

import { FLOWS_PROJECT_ROLES_COLUMN_ID } from "./constants";

const sortRoles = (
  roles: FlowsProjectRoleBindingView[],
  sortDescriptor: SortDescriptor
): FlowsProjectRoleBindingView[] => {
  if (!sortDescriptor.column || !sortDescriptor.direction) {
    return [...roles];
  }

  const sortedRoles = [...roles];

  return sortedRoles.sort((a, b) => {
    let aValue, bValue;

    const columnId = sortDescriptor.column as FLOWS_PROJECT_ROLES_COLUMN_ID;

    switch (columnId) {
      case FLOWS_PROJECT_ROLES_COLUMN_ID.ROLE:
        aValue = a.role?.name;
        bValue = b.role?.name;
        break;
      case FLOWS_PROJECT_ROLES_COLUMN_ID.SPACE:
        aValue = a.space.name;
        bValue = b.space.name;
        break;
      case FLOWS_PROJECT_ROLES_COLUMN_ID.DESCRIPTION:
      case FLOWS_PROJECT_ROLES_COLUMN_ID.ROW_ACTIONS:
      default:
        return 0;
    }

    if (!aValue && !bValue) {
      return 0;
    }
    if (!aValue) {
      return 1;
    }
    if (!bValue) {
      return -1;
    }

    if (sortDescriptor.direction === "ascending") {
      return aValue.localeCompare(bValue);
    }

    return bValue.localeCompare(aValue);
  });
};

export const useFilteredFlowsProjectRoles = (
  roles: FlowsProjectRoleBindingView[],
  sortDescriptor: SortDescriptor
) => {
  return useMemo(() => {
    let filteredRoles = [...roles];

    if (sortDescriptor.column) {
      filteredRoles = sortRoles(filteredRoles, sortDescriptor);
    }

    return filteredRoles;
  }, [roles, sortDescriptor]);
};
